/**
 * @typedef {Object} ShareData
 * @property {string} url
 * @property {string} text
 * @property {string} [title]
 * @property {string} [file]  not supported in a lot of contexts
 */

/**
 *
 * @param {ShareData} shareData
 * @returns {Promise}
 */
export const webShare = (shareData) => {
	if (!navigator.share) return;

	return navigator.share(shareData);
};
